import SafeRateLogo from "~/components/general/SafeRateLogo";

// Same shape as the consumer site's footer (saferate-ai apps/consumer/app/
// components/Footer.tsx). The links point at saferate.com, which owns these
// pages; servicing has no copies of its own.
const C_FOOTER_LINKS = [
	{ href: "https://saferate.com/about", label: "About" },
	{ href: "https://saferate.com/privacy-policy", label: "Privacy" },
	{ href: "https://saferate.com/terms-of-use", label: "Terms" },
];

const SiteFooter = () => {
	return (
		<footer className="mt-auto border-t px-6 py-8 print:hidden">
			<div className="mx-auto flex max-w-7xl flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left">
				<a aria-label="Safe Rate home" href="https://saferate.com">
					<SafeRateLogo className="h-5 w-auto" />
				</a>
				<nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 font-medium text-[13px] text-muted-foreground">
					{C_FOOTER_LINKS.map((link) => (
						<a className="transition-colors hover:text-foreground" href={link.href} key={link.href}>
							{link.label}
						</a>
					))}
				</nav>
				<span className="text-[13px] text-muted-foreground">
					© {new Date().getFullYear()} Safe Rate Inc.
				</span>
			</div>
		</footer>
	);
};

export default SiteFooter;
